import { createTheme } from '@mui/material/styles'
import { deDE } from '@mui/x-data-grid'

import { breakpoints } from './breakpoints'
import { createMuiButtonTheme } from './component-overrides/MuiButton'
import { createMuiLink } from './component-overrides/MuiLink'
import { createMuiPaperTheme } from './component-overrides/MuiPaper'
import { palette } from './palette'
import { createTypography } from './typography'

// Add custom breakpoint to type
declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    maxContentWidth: true
  }

  interface TypographyVariants {
    staticLabel: React.CSSProperties
    staticValue: React.CSSProperties
    loginLink: React.CSSProperties
    loginTitle: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    staticLabel?: React.CSSProperties
    staticValue?: React.CSSProperties
    loginLink?: React.CSSProperties
    loginTitle?: React.CSSProperties
  }

  interface Palette {
    loginbg: Palette['primary']
    warningdark: Palette['primary']
    disabled: Palette['primary']
  }

  interface PaletteOptions {
    loginbg: PaletteOptions['primary']
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    staticLabel: true
    staticValue: true
    loginLink: true
    loginTitle: true
  }
}
declare module '@mui/material/TextField' {
  interface TextFieldPropsOverrides {
    login: true
  }
}

const defaultTheme = createTheme()

const baseTheme = createTheme({
  typography: createTypography(defaultTheme),
  palette,
  breakpoints,
})

const theme = createTheme(
  {
    ...baseTheme,
    components: {
      MuiButton: createMuiButtonTheme(baseTheme),
      MuiLink: createMuiLink(baseTheme),
      MuiPaper: createMuiPaperTheme(baseTheme),
    },
  },
  deDE
)

export default theme
